// Chuyển đổi tiêu đề thành slug cho URL
export const createSlug = (str) => {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[đĐ]/g, d => d === 'đ' ? 'd' : 'D')
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '-');
};

// Format date string from either "HH:mm DD/MM/YYYY" or "DD/MM/YYYY" to readable format
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  // Check if the date string contains time (has space and first part contains colon)
  const parts = dateString.split(' ');
  const hasTime = parts.length > 1 && parts[0].includes(':');
  
  const months = [
    'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 
    'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'
  ];
  
  if (hasTime) {
    // Format is "HH:mm DD/MM/YYYY"
    const [timePart, datePart] = [parts[0], parts[1]];
    const [day, month, year] = datePart.split('/');
    
    return `${timePart} - ${day} ${months[parseInt(month) - 1]}, ${year}`;
  } else {
    // Format is just "DD/MM/YYYY"
    const [day, month, year] = dateString.split('/');
    
    return `${day} ${months[parseInt(month) - 1]}, ${year}`;
  }
};

// Parse date string in either "HH:mm DD/MM/YYYY" or "DD/MM/YYYY" format to Date object
export const parseDateString = (dateString) => {
  if (!dateString) return new Date(0);
  
  // Check if the date string contains time (has space and first part contains colon)
  const parts = dateString.split(' ');
  const hasTime = parts.length > 1 && parts[0].includes(':');
  
  if (hasTime) {
    // Format is "HH:mm DD/MM/YYYY"
    const [timePart, datePart] = [parts[0], parts[1]];
    const [hours, minutes] = timePart.split(':').map(Number);
    const [day, month, year] = datePart.split('/').map(Number);
    
    return new Date(year, month - 1, day, hours, minutes);
  } else {
    // Format is just "DD/MM/YYYY"
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day);
  }
};

// Extract YouTube video ID from a YouTube URL
export const getYoutubeVideoId = (url) => {
  if (!url) return null;
  
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  
  return (match && match[2].length === 11) ? match[2] : null;
};
